
import React from 'react';
import PropTypes from 'prop-types';

const TotalTimeIcon = ({ className }) => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      className={`fill-current ${className}`}
      xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 4.25C5.08421 4.25 1.5 7.83421 1.5 12.25C1.5 16.6658 5.08421 20.25 9.5 20.25C13.9158 20.25 17.5 16.6658 17.5 12.25C17.5 7.83421 13.9158 4.25 9.5 4.25ZM0 12.25C0 7.00579 4.25579 2.75 9.5 2.75C14.7442 2.75 19 7.00579 19 12.25C19 17.4942 14.7442 21.75 9.5 21.75C4.25579 21.75 0 17.4942 0 12.25Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 6.25C9.91421 6.25 10.25 6.58579 10.25 7V12C10.25 12.4142 9.91421 12.75 9.5 12.75C9.08579 12.75 8.75 12.4142 8.75 12V7C8.75 6.58579 9.08579 6.25 9.5 6.25Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75 1C5.75 0.585786 6.08579 0.25 6.5 0.25H12.5C12.9142 0.25 13.25 0.585786 13.25 1C13.25 1.41421 12.9142 1.75 12.5 1.75H6.5C6.08579 1.75 5.75 1.41421 5.75 1Z" fill="currentColor"/>
    </svg>
  );
};

TotalTimeIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

TotalTimeIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default TotalTimeIcon;